import Rules from '@/services/validation/rules/rules'
export default {
  data() {
    return {
      // spoilRules: [
      //     v => Rules.isRequired(v),
      // ],
      siteRules: [
        v => Rules.isRequired(v),
      ],
      dateRules: [
        v => Rules.isRequired(v),
      ],
      notesRules: [
        v => Rules.minLength(v, 1),
        v => Rules.maxLength(v, 100)
      ]

    }
  }
}

